export class MessageError extends Error {
    private readonly status: number = 500;

    constructor(message: string, status?: number | string) {
        super(message);
        this.name = 'ValidationError';
        if (status) {
            this.status = parseInt(status.toString());
        }
    }

    getStatus(): number {
        return this.status;
    }
}
